import React from 'react';
import styled from 'styled-components';

import { StyledModal, StyledModalBody } from './Modals';
import { Button } from './ui/Button';
import { Icon } from '../helper/icons';
import { ReactComponent as ExclamationMark } from '../assets/icons/exclamation-mark.svg';
import { Fonts, Palette } from './utils';

// Stacks above side modals, which lets a flow ask for confirmation without closing itself.
const STACKED_MODAL_CSS = `
  .modal {
    z-index: 1600;
  }

  .modal-backdrop {
    z-index: 1550;
  }
`;

const ConfirmModal = ({
  show,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  disabled = false
}) => (
  <StyledModal
    show={show}
    onClose={onCancel}
    closeOnBackdrop={false}
    width={'382px'}
    cssOverride={STACKED_MODAL_CSS}>
    <IconContainer>
      <Icon icon={ExclamationMark} />
    </IconContainer>
    <Title>{title}</Title>
    <StyledModalBody>
      <Text>{description}</Text>
    </StyledModalBody>
    <ButtonContainer>
      <Button
        type="button"
        isPrimary
        text={confirmText}
        onClick={onConfirm}
        disabled={disabled}
      />
      <Button type="button" text={cancelText} onClick={onCancel} disabled={disabled} />
    </ButtonContainer>
  </StyledModal>
);

const Title = styled.p`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  text-align: center;

  margin-bottom: 0;
`;

const Text = styled.p`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-align: center;

  margin-bottom: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default ConfirmModal;
